<template>
  <div class="chart-line">
    <div class="line-header">
      <div class="line-title">
        <!-- {{childQuery}} -->
        <BaseIcon
          v-if="hasWritePermission"
          class="cus-home-drag-n-drop-pointer"
          name="dragNDrop"
          width="0.813rem"
          height="1.25rem"
        />
        {{ item.widgetName }}
        <div v-if="hasWritePermission" @click="deleteWidget" class="icon-title">
          <BaseIcon
            name="deleteFilled"
            width=".9125rem"
            height=".9125rem"
            v-if="item.header"
          />
        </div>
      </div>
      <div
        class="line-content-error"
        v-if="
          item.capability !== CAPABILITY_LOG &&
          item.header.isError &&
          childQuery
        "
      >
        <span
          class="line-error-percentage"
          v-if="!item.header.hidePercentageParam"
        >
          <span v-if="childSource.length == 0 && childQuery.avg">
            {{ childQuery.avg }}%
          </span>
          <span v-else> {{ getChilds('percentage', childSource) }}% </span>
        </span>
        <span class="line-errors">
          {{
            childQuery.total > 0 ? getLargeNumberByUnits(childQuery.total) : 0
          }}
          {{ $t('bm.errors') }}
        </span>
        <span>
          {{ childQuery.perMin > 0 ? childQuery.perMin : 0 }}
          {{ $t('apm.errors-per-min') }}
        </span>
      </div>
      <div
        v-else-if="
          item.capability !== CAPABILITY_LOG &&
          item.header.displayOnlyUnit &&
          childQuery
        "
        class="line-content"
      >
        {{ childQuery.avg > 0 ? childQuery.avg : 0 }} {{ item.unit }}
      </div>
      <div v-else class="line-content">
        <div
          v-if="
            item.capability !== CAPABILITY_LOG &&
            !item.header.HideCenterMiscContent &&
            childQuery
          "
          class="line-content"
        >
          <span class="line-content-calls" v-if="item.header.basicInfoStyling">
            <span :style="{ color: '#efb700' }">
              {{
                childQuery.total > 0
                  ? getLargeNumberByUnits(childQuery.total)
                  : 0
              }}
              {{ $t('bm.calls') }}
            </span>
          </span>
          <span class="line-content-calls" v-else>
            {{
              childQuery.total > 0 ? getLargeNumberByUnits(childQuery.total) : 0
            }}
            {{ $t('bm.calls') }}
          </span>
          <span v-if="item.header.basicInfoStyling">
            <span :style="{ color: '#efb700' }">
              {{ childQuery.perMin > 0 ? childQuery.perMin : 0 }}
              {{ $t('callsPerMin') }}
            </span>
          </span>
          <span v-else>
            {{ childQuery.perMin > 0 ? childQuery.perMin : 0 }}
            {{ $t('callsPerMin') }}
          </span>
        </div>
      </div>
      <div class="capability">
        <span class="icon-capability">
          <BaseIcon
            :name="
              item.capability === CAPABILITY_DBM
                ? 'database'
                : item.capability.toLowerCase()
            "
            width=".9125rem"
            height=".9125rem"
          />
        </span>
        <span class="headings">
          {{ getCapability(item.capability) }}
        </span>
      </div>
      <div class="line-icon">
        <div class="appName" @click="redirectAppInput(item)">
          {{ item.serviceName }}
        </div>

        <div>
          <span class="icon-class" @click="handleZoomOut">
            <BaseIcon name="zoomOut" width="2.438em" height="2.438em" />
          </span>
          <span class="icon-class" @click="handleZoomIn">
            <BaseIcon name="zoomIn" width="2.438em" height="2.438em" />
          </span>
          <span class="icon-class" @click="handleReset">
            <BaseIcon name="reset" width="1.438em" height="2.438em" />
          </span>
        </div>
      </div>
    </div>
    <div class="chart-body">
      <apexchart
        height="100%"
        type="line"
        :options="chartOptions"
        :series="option"
        ref="chart"
      ></apexchart>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import BaseIcon from '@/rex-components/BaseIcon.vue';
import shortenLargeNumber from '@/utils/numberShortner';
import { MetricType, Capability, ScopeType } from '@/utils/enums/metricType';
import {
  CAPABILITY_MOBILE,
  CAPABILITY_LOG,
  CAPABILITY_ANALYTICS,
  CAPABILITY_DBM,
} from '@/utils/constants';
import {
  ToolTip,
  Legend,
  Markers,
  ChartToolBar,
  Animations,
  XAxisConfig,
  YAxisConfig,
  Grid,
} from '@/components/charts/charts.global.config';
import { VIEW_SAVED_SEARCHES_TAB_KEY } from '@/components/Log/log.constants';
import { cusGraphCapabilityLabelMapper } from '@/components/charts/util';
import { usePermissions } from '@/hooks/usePermissions';
import { HOME_RESOURCE_GROUP } from '@/router/constant';

export default {
  components: { BaseIcon },
  name: 'ChartLineCustom',
  props: {
    data: {},
    type: {},
    intervalTime: {},
    item: {},
    index: {},
    childSource: {},
    childQuery: {},
    customButtonVisible: Boolean,
    customButtonTextIfVisiable: String,
    cOptions: {},
  },
  data: function () {
    return {
      minX: 1,
      maxX: this.intervalTime.length,
      apdexColorCode: '',
      options: {
        ...this.options,
        chart: {
          //  id: `vuechart-line-${this.index}`,
          type: 'line',
          // group: 'group',
          animations: Animations,
          background: 'inherit',
          events: {
            zoomed: (chartContext, { xaxis, yaxis }) => {
              this.updateMinMax(xaxis);
            },
            beforeMount: (chartContext, config) => {
              // console.log('config', config);
              //  this.setConfig(config);
            },
          },
          toolbar: ChartToolBar,
        },
        tooltip: ToolTip,
        grid: Grid,
        colors: this.item.chartColor,
        xaxis: {
          ...XAxisConfig,
          tickAmount: this.intervalTime.length > 14 ? 5 : 3,
          title: {
            text: this.item.axisLabels.x,
            ...XAxisConfig.title,
          },
          min: this.intervalTime[0],
        },
        yaxis: {
          ...YAxisConfig,
          title: {
            text: this.item.axisLabels.y,
            ...YAxisConfig.title,
          },
        },
        legend: Legend,
        markers: Markers,
      },
    };
  },
  methods: {
    ...mapMutations('homeState', ['setdeleteWidgetId']),
    ...mapActions('apmState/apmCommonState', ['selectService']),
    ...mapActions('mobileState/mobileCommonState', ['selectMobileService']),
    ...mapActions('browserState/browserCommonState', ['selectBrowserService']),
    getCapability(capability) {
      return cusGraphCapabilityLabelMapper[capability] || capability;
    },
    deleteWidget() {
      this.setdeleteWidgetId(this.item.id);
    },
    redirectAppInput(option) {
      const query = {
        id: option.serviceKey,
      };

      switch (option.capability) {
        case Capability.APM:
          this.$router.push({
            name: 'dashboard',
            query,
          });
          break;
        case CAPABILITY_MOBILE:
          if (option.isCrashes) {
            this.$router.push({
              name: 'crashesGraphs',
              query,
            });
          } else if (option.isPerformanceGraph) {
            this.$router.push({
              name: 'performanceGraphs',
              query,
            });
          } else {
            this.$router.push({
              name: 'mobile',
              query,
            });
          }
          break;
        case CAPABILITY_LOG:
          this.$router.push({
            name: 'log',
            query: { currView: VIEW_SAVED_SEARCHES_TAB_KEY },
          });
          break;
        case CAPABILITY_ANALYTICS:
          this.$router.push({
            name: 'analytics',
            query: { currView: VIEW_SAVED_SEARCHES_TAB_KEY },
          });
          break;
        case CAPABILITY_DBM:
          this.$router.push({
            name: 'customQueryOverview',
          });
          break;
        default:
          this.$router.push({
            name: 'browser',
            query,
          });
          break;
      }
    },
    mounted() {},
    resize() {
      const chart = this.$refs.chart;
      chart.myChart.resize();
    },
    setConfig(config) {
      // console.log('configss', config.globals.maxX);
      // this.minX = config.globals.maxX;
      // this.maxX = config.globals.maxX;
    },
    handleZoomIn() {
      // Find minMax for x

      try {
        if (this.$refs.chart.chart.w.globals.minX)
          this.minX = this.$refs.chart.chart.w.globals.minX;
        if (this.$refs.chart.chart.w.globals.maxX)
          this.maxX = this.$refs.chart.chart.w.globals.maxX;
      } catch (error) {
        // Todo: Handle error
      }

      if (
        typeof this.minX === 'undefined' &&
        typeof this.maxX === 'undefined'
      ) {
        this.handleReset();
      }
      if (this.maxX - this.minX > 2) {
        const centerX = (this.minX + this.maxX) / 2;
        let newMinX = (this.minX + centerX) / 2;
        let newMaxX = (this.maxX + centerX) / 2;
        const newMinXMaxX = this._getNewMinXMaxX(newMinX, newMaxX);
        this.minX = newMinXMaxX.minX;
        this.maxX = newMinXMaxX.maxX;
        this.$refs.chart.zoomX(this.minX, this.maxX);
      }
    },
    handleReset() {
      this.$refs.chart.zoomX();
      this.minX = 1;
      this.maxX = this.intervalTime.length;
    },
    _getNewMinXMaxX(newMinX, newMaxX) {
      return {
        minX: Math.floor(newMinX),
        maxX: Math.floor(newMaxX),
      };
    },
    updateMinMax(xaxis) {
      this.minX = xaxis.min;
      this.maxX = xaxis.max;
    },
    handleZoomOut() {
      //Find minMax for x
      // This checks if min & max are undefined and resets them

      try {
        if (this.$refs.chart.chart.w.globals.minX)
          this.minX = this.$refs.chart.chart.w.globals.minX;
        if (this.$refs.chart.chart.w.globals.maxX)
          this.maxX = this.$refs.chart.chart.w.globals.maxX;
      } catch (error) {
        // Todo: Handle error
      }

      if (
        typeof this.minX === 'undefined' &&
        typeof this.maxX === 'undefined'
      ) {
        this.handleReset();
      }
      if (this.minX > 0 && this.maxX - this.minX >= 1) {
        const centerX = (this.minX + this.maxX) / 2;
        let newMinX = this.minX - (centerX - this.minX);
        let newMaxX = this.maxX - (centerX - this.maxX);
        const newMinXMaxX = this._getNewMinXMaxX(newMinX, newMaxX);
        this.minX = newMinXMaxX.minX;
        this.maxX = newMinXMaxX.maxX;
        this.$refs.chart.zoomX(this.minX, this.maxX);
      }
    },
    getChilds(type, val) {
      if (type === 'pm') {
        const item = val.find((o) => o.metricType === 'pm');
        if (item) {
          return shortenLargeNumber(item.avgNum, 1);
        } else return 0;
      } else if (type === 'percentage') {
        const item = val.find((o) => o.metricType === 'percentage');
        if (item) {
          return item.avgNum ? item.avgNum / 100 : 0;
        } else return 0;
      } else if (type === 'total') {
        const item = val.find((o) => o.metricType === 'total');
        if (item) {
          if (item.name === 'service_resp_time') {
            return item.avgNum;
          } else return shortenLargeNumber(item.avgNum, 1);
        } else return 0;
      } else return 0;
    },
    getLargeNumberByUnits(val) {
      return shortenLargeNumber(val, 1);
    },
    isApdexMatric(val) {
      const item = val.find((o) => o.metricType === 'apdex');
      if (item) {
        this.apdexColorCode = (() => {
          const val = item.avgNum ? item.avgNum : 0;
          if (val > 8400) {
            return 'good';
          } else if (val > 6800 && val < 8400) {
            return 'fair';
          } else {
            return 'poor';
          }
        })();
        return true;
      } else return false;
    },
    getApdexValue(val) {
      const item = val.find((o) => o.metricType === 'apdex');
      if (item) {
        return parseFloat(
          (!isNaN(item.avgNum) ? item.avgNum : 0) / 10000,
        ).toFixed(2);
      } else return 0;
    },
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    option() {
      const keys = Object.keys(this.data || {}).filter(
        (i) => Array.isArray(this.data[i]) && this.data[i].length,
      );
      // eslint-disable-next-line no-unused-vars
      const temp = keys.map((i, index) => {
        const serie = {
          name: i,
          data: this.data[i].map((item, itemIndex) => ({
            x:
              typeof this.intervalTime[itemIndex] === 'undefined'
                ? ''
                : this.intervalTime[itemIndex],
            y: item,
          })),
        };

        return serie;
      });
      return temp;
    },
    chartOptions() {
      return this.options;
    },

    getErrorPercentage() {
      if (this.childSource.totalValueAlt.total == 0) {
        return 0;
      }
      var error_percent =
        (this.childSource.totalValue.total /
          this.childSource.totalValueAlt.total) *
        100;
      if (isNaN(error_percent)) {
        return 0;
      }
      return error_percent.toFixed(2);
    },
    hasWritePermission() {
      const { hasCapabilityWritePermission } = usePermissions();

      return hasCapabilityWritePermission(HOME_RESOURCE_GROUP);
    },
  },

  watch: {
    minX(oldVal, newVal) {},
    item(oldVal, newVal) {
      this.options = {
        ...this.options,
        ...{
          colors: this.item.chartColor,
          yaxis: {
            ...YAxisConfig,
            title: {
              text: this.item.axisLabels.y,
              ...YAxisConfig.title,
            },
          },
        },
      };

      //this.options.x
      // this.options = {
      //   ...this.options,
      //   ...{
      //     colors: this.item.chartColor,
      //     yaxis: {
      //       title: {
      //         text: this.item.axisLabels.y
      //       }
      //     }
      //   }
      // };
      // this.options.colors = this.item.chartColor;
      // this.options = {
      //   ...this.options,
      //   yaxis: {
      //     title: {
      //       text: this.item.axisLabels.y
      //     }
      //   }
      // };
      // this.$refs.chart.updateOptions({

      // });
      // this.options.yaxis.title.text = this.item.axisLabels.y;
    },
  },
};
</script>
<style lang="scss" scoped>
.chart-body {
  margin-right: 2px;
  margin-left: 0.125em;
  height: 20.625em;
  border-radius: 1.0625em;
}

.chart-line {
  width: 100%;
  border-radius: 1.0625em;
  background-color: $bg-secondary;
}
.line-content-error {
  color: $poor;
  margin-left: auto;
  .line-error-percentage {
    margin-right: 1.125rem;
  }
  .line-errors {
    margin-right: 1em;
  }
}
.line-content {
  margin-left: auto;
  .line-content-calls {
    margin-right: 1.3em;
  }
}
.line-header {
  height: 2.375em;
  border-bottom: 0.0063em solid $border-primary;
  @include flex-center-justify(space-between);
  color: $font-primary;

  .line-title {
    margin-left: 0.8625em;
    font-family: $semi-bold;
    fill: $color-brand-accent;
    display: flex;
  }
  .icon-title {
    cursor: pointer;
    margin-left: 0.4em;
    margin-top: -0.1em;
  }
  .line-icon {
    margin-right: 0.8125em;
    @include flex-center-justify(space-between);
  }
  .icon-class:hover {
    cursor: pointer;
    svg {
      fill: $font-secondary !important;
    }
  }
  .icon-class {
    fill: $color-brand-accent !important;
  }
  .icon-class:last-child {
    margin-left: 0.3125em;
  }
  .icon-class:first-child {
    margin-right: -0.3125em;
  }
}
.appName {
  height: 1.875em;
  color: $color-brand-accent;
  cursor: pointer;
  font-family: $semi-bold;
  font-size: 0.75em;
  text-align: center;
  align-items: center;
  padding-top: 2px;
  &:hover {
    text-decoration: underline;
  }
}
.apdex {
  padding-left: 20px;
}
.apdex.poor {
  color: $poor;
}
.apdex.fair {
  color: $fair;
}
.apdex.good {
  color: $good;
}
.capability {
  height: 1.875em;
  color: $font-primary;
  font-family: $semi-bold;
  font-size: 0.75rem;
  text-align: center;
  align-items: center;
  margin-left: auto;
  margin-right: 1rem;
  padding-top: 2px;
  .icon-capability {
    fill: $font-primary;
    margin-right: 0.3125em;
  }
}
.cus-home-drag-n-drop-pointer {
  fill: $color-brand-accent;
  margin-right: 0.5rem;
  cursor: pointer;
}
</style>
